import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './ProjectFilter.css';

const ProjectFilter = ({ projects, onFilteredProjects }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = [
    { id: 'all', name: 'All Projects', icon: 'fas fa-th' },
    { id: 'fullstack', name: 'Full Stack', icon: 'fas fa-layer-group' },
    { id: 'backend', name: 'Backend', icon: 'fas fa-server' },
    { id: 'frontend', name: 'Frontend', icon: 'fas fa-desktop' },
    { id: 'mobile', name: 'Mobile', icon: 'fas fa-mobile-alt' },
    { id: 'ai', name: 'AI/ML', icon: 'fas fa-brain' }
  ];

  const filterProjects = (category, search) => {
    let filtered = projects;

    if (category !== 'all') {
      filtered = projects.filter(project => 
        project.category === category || 
        project.tech.toLowerCase().includes(category)
      );
    }

    if (search) {
      filtered = filtered.filter(project =>
        project.title.toLowerCase().includes(search.toLowerCase()) ||
        project.tech.toLowerCase().includes(search.toLowerCase()) ||
        project.details.toLowerCase().includes(search.toLowerCase())
      );
    }

    onFilteredProjects(filtered);
  };

  const handleFilterChange = (category) => {
    setActiveFilter(category);
    filterProjects(category, searchTerm);
  };

  const handleSearchChange = (e) => {
    const search = e.target.value;
    setSearchTerm(search);
    filterProjects(activeFilter, search);
  };

  return (
    <div className="project-filter">
      <motion.div 
        className="search-container"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="search-input-wrapper">
          <i className="fas fa-search search-icon"></i>
          <input
            type="text"
            placeholder="Search projects by technology, title, or description..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="search-input"
          />
          {searchTerm && (
            <motion.button
              className="clear-search"
              onClick={() => {
                setSearchTerm('');
                filterProjects(activeFilter, '');
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <i className="fas fa-times"></i>
            </motion.button>
          )}
        </div>
      </motion.div>

      <motion.div 
        className="filter-categories"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {categories.map((category) => (
          <motion.button
            key={category.id}
            className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`}
            data-category={category.id}
            onClick={() => handleFilterChange(category.id)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <i className={category.icon}></i>
            <span>{category.name}</span>
          </motion.button>
        ))}
      </motion.div>
    </div>
  );
};

export default ProjectFilter;
